import type { MRT_TableOptions } from 'mantine-react-table';

import type { TFunction } from 'i18next';

import { EmptyPlaceholder } from '../../../../../../../shared/components/UI/EmptyPlaceholder/EmptyPlaceholder';

import type { FindAllProjectResponsesResponseDTO } from '../../../../../../../shared/entities/ProjectResponse';
import { TableColumn } from './columnsDefinition';

export type ProjectTableData =
  FindAllProjectResponsesResponseDTO['projects'][number];

type TableConfig = Partial<MRT_TableOptions<ProjectTableData>>;

export function getProjectResponseTableConfig(
  t: TFunction<'bidResponse'>,
  { onRowClick }: { onRowClick: (row: ProjectTableData) => void },
): TableConfig {
  return {
    memoMode: 'cells',
    layoutMode: 'grid',
    enableStickyHeader: true,
    enableSorting: false,
    enableColumnActions: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableTableFooter: true,
    enablePinning: true,
    initialState: {
      density: 'xs',
      columnPinning: {
        left: [TableColumn.TITLE],
      },
    },
    state: { columnOrder: [] },
    mantinePaperProps: { withBorder: false, p: 6, radius: 16 },
    mantineTableProps: {
      sx: () => ({
        '*': {
          boxShadow: 'none !important',
          border: 'none !important',
        },
        'tbody tr:hover': {
          backgroundColor: 'white !important',
        },
      }),
    },
    mantineTableContainerProps: {
      sx: {
        height: `auto`,
      },
    },
    mantineTableHeadRowProps: {
      sx: theme => ({
        borderBottom: `1px solid ${theme.colors.gray[1]} !important`,
        'th > div ': {
          color: theme.colors.gray[6],
          fontWeight: 500,
          fontSize: theme.fontSizes.xs,
        },
      }),
    },
    mantineTableHeadCellProps: ({ column }) => ({
      sx: () => ({
        border: column.getIsPinned() ? '1px solid white !important' : 'none',
        borderLeft: 'none !important',
        borderRight: 'none !important',
      }),
    }),

    mantineTableBodyRowProps: ({ row: { original: bidResponse } }) => ({
      sx: theme => ({
        borderBottom: `1px solid ${theme.colors.gray[1]} !important`,
        color: 'inherit',
        cursor: 'pointer',
      }),
      onClick: () => {
        onRowClick(bidResponse);
      },
    }),

    renderEmptyRowsFallback: () => (
      <EmptyPlaceholder
        title={t('vault.bidResponseTable.emptyPlaceholder.title')}
        subtitle={t('vault.bidResponseTable.emptyPlaceholder.subtitle')}
      />
    ),
  };
}
